import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import clsx from 'clsx';
import { Music24PlanTier } from 'fym-common/src/license/music24Plans';
import { TypedMemo } from '../../../../common/types';
import { planNameMessages } from '../../../config/music24PlanNames';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the compare table; each part uses its own slice of it */
import styles from './PricingCompareTable.module.scss';
/* eslint-enable css-modules/no-unused-class */

/** A column of the compare table: every tier but `trial`, which is not sold. */
export type CompareTier = Exclude<Music24PlanTier, 'trial'>;

const messages = defineMessages({
  label: { id: 'app.sml.plans.compare.pairLabel', defaultMessage: 'Compare Pro with' },
});

interface CompareTierSwitchProps {
  options: CompareTier[];
  value: CompareTier;
  onChange: (tier: CompareTier) => void;
}

/**
 * The switch above the compare table on a phone (design plans-page a3): the table then shows Pro
 * and the plan picked here. A wider screen shows every column, so the switch is hidden there.
 */
const CompareTierSwitchComponent: React.FC<CompareTierSwitchProps> = ({ options, value, onChange }) => {
  const intl = useIntl();
  const label = intl.formatMessage(messages.label);

  return (
    <div className={styles.pair}>
      <span className={styles.pairLabel}>{label}</span>
      <div className={styles.pairSeg} role="radiogroup" aria-label={label}>
        {options.map((tier) => (
          <button
            key={tier}
            type="button"
            role="radio"
            aria-checked={tier === value}
            className={clsx(tier === value && styles.pairOn)}
            onClick={() => onChange(tier)}
          >
            {intl.formatMessage(planNameMessages[tier])}
          </button>
        ))}
      </div>
    </div>
  );
};

export const CompareTierSwitch = TypedMemo(CompareTierSwitchComponent);
